import { ProjectCard } from "@/components/ProjectCard";
import { Section } from "@/components/Section";
import { alsoShipped, projects } from "@/data/projects";
import { useLocale } from "@/i18n/locale";
import { ui } from "@/i18n/ui";

export function SelectedWork() {
  const { t } = useLocale();

  return (
    <Section id="work" label={ui.selectedWork} title={ui.selectedWorkNote}>
      <div>
        {projects.map((project, index) => (
          <ProjectCard key={project.id} project={project} index={index} />
        ))}
      </div>

      <div className="mt-12 border-t border-border pt-8">
        <h3 className="label mb-5 text-faint">{t(ui.alsoShipped)}</h3>
        <ul className="grid gap-x-8 gap-y-3 sm:grid-cols-2">
          {alsoShipped.map((item) => (
            <li key={item.name} className="text-sm text-muted text-pretty">
              <span className="text-text">{item.name}</span>
              <span className="text-faint"> — {t(item.note)}</span>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}
